module.exports = __webpack_public_path__ + "assets/search-mobile-a2f4833c714b06630cccd72a1d69f7d0.svg";